/* action type */
import type { Action } from '../../store/state/state-manager';

export const CANCEL_ASSIGNMENT = 'CANCEL_ASSIGNMENT';

/* action creator */
export const cancelAssignmentAction = (actionPayload: Action['payload']) => {
  return {
    type: CANCEL_ASSIGNMENT,
    payload: actionPayload
  };
};
